import { Portal, ClickAwayListener } from '@mui/base';
import clsx from 'clsx';
import React, { forwardRef, useCallback, useEffect, useMemo, useState, useRef } from 'react';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["className"];
var DefaultInput = function DefaultInput(props) {
  var className = props.className,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return React.createElement("input", Object.assign({
    className: clsx('react-loqate-input', className),
    "data-testid": "default-input"
  }, rest));
};

var _excluded$1 = ["className"];
var DefaultList = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    rest = _objectWithoutPropertiesLoose(props, _excluded$1);
  return React.createElement("ul", Object.assign({
    className: clsx('react-loqate-default-list', className),
    "data-testid": "default-list"
  }, rest, {
    ref: ref
  }));
});

var _excluded$2 = ["className", "value", "children", "suggestion"];
var DefaultListItem = function DefaultListItem(props) {
  var _result$slice;
  var className = props.className,
    value = props.value,
    suggestion = props.suggestion,
    rest = _objectWithoutPropertiesLoose(props, _excluded$2);
  var regex = new RegExp("(.*)(" + (value == null ? void 0 : value.toString().replace(/\W/g, '')) + ")(.*)", 'i');
  var search = suggestion.Text + " " + suggestion.Description;
  var result = search.match(regex);
  var _ref = (_result$slice = result == null ? void 0 : result.slice(1)) != null ? _result$slice : ['', '', ''],
    before = _ref[0],
    match = _ref[1],
    after = _ref[2];
  return React.createElement("li", Object.assign({
    className: clsx('react-loqate-list-item', className),
    "aria-label": match,
    tabIndex: 0
  }, rest), (result == null ? void 0 : result.length) === 4 ? React.createElement(React.Fragment, null, before, React.createElement("strong", null, match), after) : search);
};

var LOQATE_BASE_URL = 'https://api.addressy.com/Capture/Interactive';
var LOQATE_RETRIEVE_URL = 'Retrieve/v1/json3.ws';
var LOQATE_FIND_URL = 'Find/v1.10/json3.ws';

var Loqate = /*#__PURE__*/function () {
  function Loqate(key, baseUrl) {
    if (baseUrl === void 0) {
      baseUrl = LOQATE_BASE_URL;
    }
    this.key = key;
    this.baseUrl = baseUrl;
  }
  Loqate.create = function create(key, baseUrl) {
    if (baseUrl === void 0) {
      baseUrl = LOQATE_BASE_URL;
    }
    return new Loqate(key, baseUrl);
  };
  var _proto = Loqate.prototype;
  _proto.retrieve = /*#__PURE__*/function () {
    var _retrieve = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id) {
      var params, url;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = new URLSearchParams({
              Id: id,
              Key: this.key
            });
            url = this.baseUrl + "/" + LOQATE_RETRIEVE_URL + "?" + params.toString();
            return _context.abrupt("return", fetch(url).then(function (r) {
              return r.json();
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function retrieve(_x) {
      return _retrieve.apply(this, arguments);
    }
    return retrieve;
  }();
  _proto.find = /*#__PURE__*/function () {
    var _find = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(query) {
      var _response$Items;
      var text, _query$countries, countries, containerId, language, limit, params, url, response, error;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            text = query.text, _query$countries = query.countries, countries = _query$countries === void 0 ? [] : _query$countries, containerId = query.containerId, language = query.language, limit = query.limit;
            params = new URLSearchParams({
              Text: text,
              Countries: countries.join(','),
              language: language,
              Key: this.key
            });
            if (containerId) {
              params.set('Container', containerId);
            }
            if (limit) {
              params.set('limit', limit.toString());
            }
            url = this.baseUrl + "/" + LOQATE_FIND_URL + "?" + params.toString();
            _context2.next = 7;
            return fetch(url).then(function (r) {
              return r.json();
            });
          case 7:
            response = _context2.sent;
            error = response == null ? void 0 : (_response$Items = response.Items) == null ? void 0 : _response$Items.find(function (item) {
              return item.Error;
            });
            if (!error) {
              _context2.next = 11;
              break;
            }
            throw new Error("Loqate error: " + JSON.stringify(error));
          case 11:
            return _context2.abrupt("return", response);
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function find(_x2) {
      return _find.apply(this, arguments);
    }
    return find;
  }();
  return Loqate;
}();

function useDebounceEffect(effect, delay, deps) {
  var callback = useCallback(effect, deps);
  useEffect(function () {
    if (!delay) {
      callback();
      return;
    }
    var handler = setTimeout(function () {
      callback();
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [callback, delay]);
}

var loqateLanguage = function loqateLanguage(language) {
  var _language$replace$spl = language.replace('_', '-').split('-'),
    languageCode = _language$replace$spl[0];
  return languageCode;
};
function AddressSearch(props) {
  var _anchorRef$current, _components$Input, _components$List, _components$ListItem, _rect$y, _rect$left, _rect$width;
  var locale = props.locale,
    countries = props.countries,
    onSelect = props.onSelect,
    limit = props.limit,
    apiKey = props.apiKey,
    className = props.className,
    classes = props.classes,
    components = props.components,
    inline = props.inline,
    debounce = props.debounce;
  var loqate = useMemo(function () {
    return Loqate.create(apiKey);
  }, [apiKey]);
  var _useState = useState([]),
    suggestions = _useState[0],
    setSuggestions = _useState[1];
  var _useState2 = useState(''),
    value = _useState2[0],
    setValue = _useState2[1];
  var anchorRef = useRef(null);
  var rect = (_anchorRef$current = anchorRef.current) == null ? void 0 : _anchorRef$current.getBoundingClientRect();
  function find(_x, _x2) {
    return _find.apply(this, arguments);
  }
  function _find() {
    _find = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(text, containerId) {
      var _yield$loqate$find, Items;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loqate.find({
              countries: countries,
              limit: limit,
              text: text,
              containerId: containerId,
              language: loqateLanguage(locale)
            });
          case 2:
            _yield$loqate$find = _context.sent;
            Items = _yield$loqate$find.Items;
            return _context.abrupt("return", Items != null ? Items : []);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _find.apply(this, arguments);
  }
  function selectSuggestion(_x3) {
    return _selectSuggestion.apply(this, arguments);
  }
  function _selectSuggestion() {
    _selectSuggestion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
      var Type, Id, _yield$loqate$retriev, _yield$loqate$retriev2, Items, items;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            Type = _ref.Type, Id = _ref.Id;
            if (!(Type === 'Address')) {
              _context2.next = 10;
              break;
            }
            _context2.next = 4;
            return loqate.retrieve(Id);
          case 4:
            _yield$loqate$retriev = _context2.sent;
            _yield$loqate$retriev2 = _yield$loqate$retriev.Items;
            Items = _yield$loqate$retriev2 === void 0 ? [] : _yield$loqate$retriev2;
            if (Items.length) {
              setSuggestions([]);
            }
            onSelect(Items[0]);
            return _context2.abrupt("return");
          case 10:
            _context2.next = 12;
            return find(value, Id);
          case 12:
            items = _context2.sent;
            setSuggestions(items);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _selectSuggestion.apply(this, arguments);
  }
  function handleChange(_x4) {
    return _handleChange.apply(this, arguments);
  }
  function _handleChange() {
    _handleChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref2) {
      var target, search;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            target = _ref2.target;
            search = target.value;
            setValue(search);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _handleChange.apply(this, arguments);
  }
  useDebounceEffect(function () {
    if (value === '') {
      setSuggestions([]);
      return;
    }
    find(value).then(setSuggestions);
  }, debounce, [value]);
  var Input = (_components$Input = components == null ? void 0 : components.Input) != null ? _components$Input : DefaultInput;
  var List = (_components$List = components == null ? void 0 : components.List) != null ? _components$List : DefaultList;
  var ListItem = (_components$ListItem = components == null ? void 0 : components.ListItem) != null ? _components$ListItem : DefaultListItem;
  return React.createElement("div", {
    ref: anchorRef,
    className: className,
    "data-testid": "react-loqate"
  }, React.createElement(Input, {
    className: clsx(classes == null ? void 0 : classes.input),
    onChange: handleChange,
    value: value,
    "data-testid": "react-loqate-input",
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Escape') {
        setSuggestions([]);
      }
    }
  }), React.createElement(Portal, {
    container: document.body,
    disablePortal: inline
  }, React.createElement(ClickAwayListener, {
    onClickAway: function onClickAway() {
      return setSuggestions([]);
    }
  }, React.createElement(List, {
    style: {
      position: 'absolute',
      top: rect ? ((_rect$y = rect.y) != null ? _rect$y : 0) + rect.height + window.scrollY : 0,
      left: (_rect$left = rect == null ? void 0 : rect.left) != null ? _rect$left : 0,
      width: (_rect$width = rect == null ? void 0 : rect.width) != null ? _rect$width : undefined
    },
    hidden: !suggestions.length,
    className: classes == null ? void 0 : classes.list,
    "data-testid": "react-loqate-list"
  }, suggestions.map(function (suggestion, i) {
    return React.createElement(ListItem, {
      key: suggestion.Id + i,
      onClick: function onClick() {
        return selectSuggestion(suggestion);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          selectSuggestion(suggestion);
        }
        if (e.key === 'Escape') {
          setSuggestions([]);
        }
      },
      className: classes == null ? void 0 : classes.listItem,
      "data-testid": "react-loqate-list-item-" + suggestion.Id,
      value: value,
      suggestion: suggestion
    }, suggestion.Text, " ", suggestion.Description);
  })))));
}

export default AddressSearch;
//# sourceMappingURL=react-loqate.esm.js.map
